import * as Collapsible from '@radix-ui/react-collapsible'
import React, { PropsWithChildren } from 'react'

interface CollapseProps {
    open?: boolean
}

export default function Collapse(props: PropsWithChildren<CollapseProps>) {
    return (
        <Collapsible.Root open={props.open}>
            <Collapsible.Content>
                {props.children}
            </Collapsible.Content>
        </Collapsible.Root>
    )
}
